import { computed, watch } from 'vue';
import Widget from '../../Widget/Widget';
import { WidgetTypes } from 'interfaces';
import { store } from '@/store/store';
import { ScoreDeterminantType } from '@studyportals/bestfit-api-fe-client';
import { ScoreTypes } from '@/enums/score-types';
import EventsSender from '@/infrastruture/events/EventsSender';

export default class BannerFinal extends Widget {
	public scoreTypeGradientCircle = ScoreTypes.GRADIENT_CIRCLE;
	private imageBaseUrl = '//monet-prtl-co.imgix.net/Shared/BestFit';

	constructor(
		studyId: number,
		widgetType: WidgetTypes,
		widgetLocation: string,
		emptyText: string,
	) {
		super(studyId, widgetType, widgetLocation, emptyText);
	}

	public beforeMount(): void {
		store.mutations.setActiveStudyId(this.studyId);
	}

	public mounted(): void {
		EventsSender.sendWishlistEvents();
		watch(this.bestFitScore, () => EventsSender.sendWishlistEvents());
	}

	public imageSource = computed((): string => {
		if (this.isMobile.value) {
			return `${this.imageBaseUrl}/bestfit_banner_watermark_mobile.svg`;
		}
		return `${this.imageBaseUrl}/bestfit_banner_watermark_desktop.svg`;
	});

	public bestFitScore = computed((): number | null => {
		const score =
			store.getters
				.getActiveStudyStore()
				?.getters.scoreByDeterminant(ScoreDeterminantType.OVERALL_FIT) ?? 0;
		return Math.round(score / 10) * 10;
	});

	public isMobile = computed((): boolean => {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		if (!window['Shared'] || !window['Shared']['breakpoints']) {
			return false;
		}
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
		return window['Shared']['breakpoints'](['Small', 'Medium']);
	});

	public isLargeScreen = computed((): boolean => {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		if (!window['Shared'] || !window['Shared']['breakpoints']) {
			return false;
		}
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
		return window['Shared']['breakpoints'](['Large']);
	});

	public displayScoreText = computed((): string => {
		if (this.bestFitScore.value === null) {
			return '';
		}
		if (this.bestFitScore.value <= 70) {
			return 'Find out how to improve your match!';
		}
		if (this.bestFitScore.value > 70 && !this.isMobile.value) {
			return 'Save this programme to compare it with others!';
		}
		if (this.bestFitScore.value > 70 && this.isMobile.value) {
			return 'Save this programme to compare';
		}
		return '';
	});

	public showWishlistButton = computed((): boolean => {
		if (this.bestFitScore.value === null) {
			return false;
		}
		if (this.bestFitScore.value <= 70) {
			return false;
		}
		return true;
	});
}
